import * as React from 'react';

/**
 *
 * these controls appear when editing a feature; they allow a user
 * to create a new entity or query features
 *
 * */

export class EditControls extends React.PureComponent<any, any> {
    render () {
        const editMode = this.props.editMode.toLowerCase();
        const message = this.props.message;
        const showSave = editMode !== 'bufferexisting';
        const saveEnabled = this.props.saveEnabled;
        const showQuery = !this.props.isEditingGeometry;
        const saveText = showQuery ? 'Create New Entity' : 'Set Geometry';
        const cancelText = showQuery ? 'Cancel' : 'Back';
        return (
            <div className="editControlsContainer">
                <div>
                    {showQuery && <div style={{backgroundColor: '#3b71fb'}} onClick={this.props.query}>Query</div>}
                    {showSave &&
                        <div className={saveEnabled ? '' : 'disabled'}
                             style={{backgroundColor: saveEnabled ? '#27c56d' : '#8b8c89'}}
                             onClick={saveEnabled ? this.props.save : () => {}}>{saveText}</div>
                    }
                    <div style={{backgroundColor: '#c84f3e'}} onClick={this.props.cancel}>{cancelText}</div>
                </div>
                {(message && showSave) && <div className="editControlsMessage">
                    <div>{message}</div>
                </div>}
            </div>
        )
    }
}